import React from "react";
import { observer, inject } from "mobx-react";
import SwitchCityLayout from "Layouts/switchCityLayout";
import { graphql } from "@apollo/client/react/hoc";
import {
	SITE_CONFIG_QUERY,
	SEARCH_REGIONS_IN_DISTRICTS_QUERY,
	SEARCH_REGIONS_MOSKVAONLINE,
} from "Services/queries";
import { Loading } from "ComponentsUI/Loading";
import { withRouter, Link } from "react-router-dom";
import withDefaultParams from "Services/withDefaultParams";
import { generateUrl } from "Services/withDefaultParams";
import Routes from "Configs/routes";
import compose from "recompose/compose";
import cookie from "js-cookie";

@inject("ApplicationModel")
@observer
class SwitchCityLayoutContainer extends React.Component {
	static defaultProps = {
		className: "",
	};

	render() {
		if (!this.props.data.siteConfig) return <Loading fullScreen={true} />;
		let regions = this.props.data.siteConfig.regions.available;
		let text = this.props.ApplicationModel.text;
		let element = <Link to="" />;
		let currentRegion = this.props.ApplicationModel.currentRegion;
		let previusPath =
			!!currentRegion && currentRegion.url
				? this.props.ApplicationModel.commonViewModel.previousPath
				: "/";
		if (!previusPath) {
			if (!!currentRegion && currentRegion.url) {
				previusPath = generateUrl(Routes.Default.route, {
					regionUrl: currentRegion.url,
				});
			} else {
				previusPath = "/";
			}
		}
		let alphabet = {
			regions: regions,
			regionsInDistricts: this.props.regionsInDistricts,
			cityImportant:
				this.props.siteCode == "101internet"
					? regions.filter((o) => o.id == 77 || o.id == 78 || o.id == 50 || o.id == 47)
					: this.props.siteCode == "moskvaonline"
						? regions.filter((o) => o.id == 77 || o.id == 50)
						: [],
		};

		return (
			<SwitchCityLayout
				{...this.props}
				windowSizes={this.props.ApplicationModel.windowSizeModel.windowSizes}
				defaultRegion={this.props.data.siteConfig.regions.default}
				alphabet={alphabet}
				element={element}
				text={text}
				searcheValue={this.props.searcheValue}
				findChangeHandler={this.props.findChangeHandler}
				linkComponent={<Link to={previusPath} />}
			/>
		);
	}
}

export default withRouter(
	withDefaultParams(
		compose(
			graphql(SITE_CONFIG_QUERY),
			graphql(SEARCH_REGIONS_IN_DISTRICTS_QUERY, {
				skip: (ownProps) => {
					return ownProps.searcheValue.length < 3;
				},
				options: (props) => {
					let sessionId = cookie.get("uuid");

					let query = `query=${props.searcheValue}`;
					if (props.siteCode === "moskvaonline") {
						query += `&region_id=77`;
					}
					if (props.siteCode === "piteronline") {
						query += `&region_id=78`;
					}
					if (sessionId) {
						query += `&session_id=${sessionId}`;
					}
					return {
						variables: {
							filter: query,
						},
					};
				},
				props: ({ ownProps, data }) => {
					if (data.searchRegionInDistricts) {
						if (!data.searchRegionInDistricts.data) {
							return { regionsInDistricts: [] };
						} else {
							const newRegions = data.searchRegionInDistricts.data.map((item) => {
								return {
									id: item.data.id,
									district_id: item.data.id,
									district_region_id: item.data.region_id,
									name: item.data.region
										? `${item.data.name} (${item.data.region})`
										: item.data.name,
									url: item.data.region_url,
								};
							});
							return {
								...ownProps,
								regionsInDistricts: newRegions,
							};
						}
					}

					return { regionsInDistricts: [] };
				},
			}),
			graphql(SEARCH_REGIONS_MOSKVAONLINE, {
				skip: (ownProps) => {
					return ownProps.searcheValue.length > 2;
				},

				props: ({ ownProps, data }) => {
					if (!data.districts) {
						return { moskovskayaoOblastCities: [] };
					} else {
						let allowedListСities = [
							488, 422, 454, 1497, 441, 1493, 459, 442, 440, 430, 437, 493, 453, 455, 444, 1485,
							428, 494, 468, 433, 20364, 445, 457, 426, 1486, 496, 1499, 425, 450, 438, 429, 432,
							424, 20326, 436, 439, 443, 434, 458, 1482, 461, 423, 452, 435, 467, 427,
						];
						const newCities = data.districts.data
							.filter((city) => allowedListСities.includes(city.id))
							.map((item) => {
								return {
									id: item.region.id,
									image_lg: null,
									image_md: null,
									image_sm: null,
									image_xs: null,
									info_popup: 0,
									is_capital: 0,
									is_show_qwiz: true,
									name: item.name,
									qwiz_end_time: 24,
									qwiz_start_time: 0,
									url: "moskovskaya-oblast",
								};
							})
							.sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0));

						return {
							...ownProps,
							moskovskayaoOblastCities: newCities,
						};
					}
				},
			})
		)(SwitchCityLayoutContainer)
	)
);
// export default withRouter(
//     withDefaultParams(
//         compose(graphql(SITE_CONFIG_QUERY))(SwitchCityLayoutContainer)
//     )
// );
